// extracted by mini-css-extract-plugin
export default {"container":"ApprovalThumbnail_container__CLJfL","small":"ApprovalThumbnail_small__RmmwO","tag":"ApprovalThumbnail_tag__HCMY9"};